/** Cross-cutting constants referenced by both API and web. */
/** §12.3 — cursor pagination. */
export const DEFAULT_PAGE_SIZE = 100;
export const MAX_PAGE_SIZE = 200;
/** §7.7 — bulk actions operate on at most this many cards per request. */
export const BULK_MAX_TASKS = 200;
/** §7.7, D18 — how long an undo token stays redeemable. */
export const UNDO_TTL_SECONDS = 600;
/** §7.2 — CSV export ceiling. */
export const EXPORT_MAX_ROWS = 10_000;
/** §6.8 — attachment limits. `MAX_UPLOAD_MB` is env-overridable server-side. */
export const DEFAULT_MAX_UPLOAD_MB = 100;
export const MAX_FILES_PER_REQUEST = 20;
export const THUMBNAIL_MAX_PX = 400;
/** §14.3 — "an automation-caused event does not re-trigger automations beyond depth 3". */
export const MAX_AUTOMATION_DEPTH = 3;
/** §6.4, D4 — subtasks are one level deep. */
export const MAX_SUBTASK_DEPTH = 1;
/** §6.10 — audit payloads store truncated text, never full ProseMirror JSON. */
export const AUDIT_TEXT_SNIPPET_MAX = 500;
/** §6.13 — a timer running longer than this asks for confirmation. */
export const TIMER_CONFIRM_HOURS = 12;
/** §6.14 — project health older than this is flagged stale. */
export const PROJECT_HEALTH_STALE_DAYS = 14;
/** §6.16 — how many similar-card suggestions to surface while typing a title. */
export const SIMILAR_CARDS_LIMIT = 5;
/** §12.5 — per-token rate limit. */
export const AGENT_RATE_LIMIT_PER_MIN = 120;
/**
 * §12.5's `read_attachment` limits — "images return as MCP image content,
 * server-side downscaled to ≤1568px and re-encoded ≤3 MB".
 *
 * 1568px is the long edge Claude's vision pipeline resizes to anyway, so
 * sending more is bytes for nothing.
 */
export const AGENT_IMAGE_MAX_EDGE = 1568;
export const AGENT_IMAGE_MAX_BYTES = 3 * 1024 * 1024;
/** Text-ish attachments are truncated rather than refused, with a notice. */
export const AGENT_TEXT_MAX_CHARS = 200_000;
/** A base64 upload from an agent — §12.5's `add_attachment`. */
export const AGENT_UPLOAD_MAX_MB = 20;
/** §11.2 — instant-mode coalescing window, per (user, card). */
export const INSTANT_COALESCE_SECONDS = 60;
/**
 * §11.2 — how long the digest leaves an *exception* notification alone.
 *
 * `mention` and `assignment` email instantly even in digest mode, so those
 * rows belong to the instant path. Without a hands-off period the five-minute
 * digest sweep can claim a fresh mention before the delayed instant job fires,
 * and the mention arrives batched — the exact opposite of the rule.
 *
 * Long enough to cover the coalescing window and a retry or two; short enough
 * that a permanently failed instant send is still rescued by the next digest
 * rather than lost.
 */
export const INSTANT_RESCUE_SECONDS = 300;
/** §18.2 — soft-deleted cards/comments/attachments purge after this long. */
export const SOFT_DELETE_PURGE_DAYS = 30;
/** §9.1 — session lifetime (rolling). */
export const SESSION_TTL_DAYS = 30;
/** §9.1 — invite links expire after this long. */
export const INVITE_TTL_DAYS = 7;
/** §9.1 — CSRF: state-changing requests must carry this header. */
export const CLIENT_HEADER = 'x-slate-client';
export const CLIENT_HEADER_VALUE = 'web';
/** Session cookie name. */
export const SESSION_COOKIE = 'slate_sid';
/** §12.5 — personal access token prefix; `slate_pat_` + random. */
export const PAT_PREFIX = 'slate_pat_';
/** Default timezone for new users — D10. */
export const DEFAULT_TIMEZONE = 'Australia/Brisbane';
//# sourceMappingURL=constants.js.map